import axios from 'axios'
import api from '@/services/api'

export default {

    register (credentials){
      alert(api.baseUrl)
      return axios.post(api.baseUrl + 'cashpos',credentials)
    },
    async fetchCompany() {
      try{
        return await axios.get(api.baseUrl + 'company' )
      }
      catch (err) {
        console.log('err' + err)
        if(!err.response){
          return '{error: "errror occured"}'
        }
      }
    },
    submit (data) {
      return axios.post(api.baseUrl + 'cashpos',data)
    },
    async fetchItem(){
      try {
        return await axios.get(api.baseUrl + "product")    
      }
      catch (err){

      }
    },
    async fetchStates() {
      try {
        return await axios.get(api.baseUrl + 'states' )
      }
      catch (err) {

      }
    },
    async fetchParty(data) {
      try {
        return await axios.get(api.baseUrl + 'party?gstin=' + data)   
      }
      catch (err) {
        console.log(err)
        return err
      }
    }
}
